import { userQueryToForm as queryToForm } from "./userQueryToForm";
import { userFormToQuery as formToQuery } from "./userFormToQuery";

export default { queryToForm, formToQuery };
